import * as React from "react";
import { IconProps } from "../types";

const FileArrowInIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
        {...props}
      >
        <path
          d="M15.16 6.25011H11.75C11.198 6.25011 10.75 5.80211 10.75 5.25011V1.85211"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.75 7.25012L9.25 9.75012L6.75 12.2501"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 12.2501V14.2501C3.75 15.3546 4.6454 16.2501 5.75 16.2501H13.1877C14.2814 16.2501 15.1723 15.3717 15.1875 14.2779L15.25 6.66442C15.25 6.39902 15.1446 6.14462 14.957 5.95712L11.0428 2.04282C10.8554 1.85532 10.6011 1.75012 10.3361 1.75012H5.7501C4.6455 1.75012 3.7501 2.64562 3.7501 3.75012V7.25012"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 9.75012H0.75"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

export default FileArrowInIcon;
